

export enum ViewportsType {
    Single,
    TB11,
    LR11,
    LR21,
    Four,
}
